import { ApiClient } from '@/services/api/client'
import { log } from '@/util/log'
import { Either, left, right } from 'fp-ts/lib/Either'

export class PowerListService {
  constructor (
    private readonly apiClient: typeof ApiClient = ApiClient
  ) {}
  async list(): Promise<Either<Error, Power[]>> {
    const target = `/api/common/usual_power/list`

    try {
      const response = await this.apiClient.get(target)

      log.debug({ service: target, response })

      return right(response.body.data)
    } catch (error) {
      log.error({ service: target, error })

      return left(error)
    }
  }
}
export interface Power {
  title: string
  pathname: string
  display_level: number
}
